import "./Pricing.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import GrowthPackages from "./sections/GrowthPackages";
import SideBySideComparison from "./sections/SideBySideComparison";
import ConsultationFaq from "./sections/ConsultationFaq";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <NavigationHeader />
      <GrowthPackages />
      <SideBySideComparison />
      <ConsultationFaq />
      <Footer />
    </div>;
}